import { css, keyframes } from 'styled-components'

import { themedKeyframes } from 'components/utils/animations'

const noDropShadow = css`
  filter: drop-shadow(transparent 0px 1px 5px)
    drop-shadow(transparent 0px 4px 14px) drop-shadow(transparent 0px 8px 24px)
    drop-shadow(transparent 0px 24px 35px);
`

const withDropShadow = css`
  /* theme.shadow.bottom.large, converted to drop-shadow */
  filter: drop-shadow(rgba(0, 0, 0, 0.1) 0px 1px 5px)
    drop-shadow(rgba(0, 0, 0, 0.05) 0px 4px 14px)
    drop-shadow(rgba(0, 0, 0, 0.05) 0px 8px 24px)
    drop-shadow(rgba(0, 0, 0, 0.05) 0px 24px 35px);
`

export const dropShadowAppear = keyframes`
  0% {
    ${noDropShadow}
  }
  100% {
    ${withDropShadow}
  }
`

export const dropShadowDisappear = keyframes`
  0% {
    ${withDropShadow}
  }
  100% {
    ${noDropShadow}
  }
`

const noBoxShadow = css`
  box-shadow: 0px 1px 5px transparent, 0px 4px 14px transparent,
    0px 8px 24px transparent, 0px 24px 35px transparent;
`

export const boxShadowAppear = themedKeyframes(
  (theme) => keyframes`
  0% {
    ${noBoxShadow}
  }
  100% {
    box-shadow: ${theme.shadow.bottom.large}
  }
`,
)

export const boxShadowDisappear = themedKeyframes(
  (theme) => keyframes`
  0% {
    box-shadow: ${theme.shadow.bottom.large}
  }
  100% {
    ${noBoxShadow}
  }
`,
)
